import { useState, useRef, useCallback } from 'react';

interface UseNavigationDropdownProps {
  closeDelay?: number;
  openDelay?: number;
}

export const useNavigationDropdown = ({
  closeDelay = 50,
  openDelay = 50,
}: UseNavigationDropdownProps = {}) => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout>();
  const mouseIsOverRef = useRef(false);

  const clearTimeouts = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = undefined;
    }
  };

  const handleMouseEnter = useCallback(() => {
    clearTimeouts();
    mouseIsOverRef.current = true;
    
    if (!isOpen) {
      timeoutRef.current = setTimeout(() => {
        if (mouseIsOverRef.current) {
          setIsOpen(true);
        }
      }, openDelay);
    }
  }, [isOpen, openDelay]);

  const handleMouseLeave = useCallback(() => {
    clearTimeouts();
    mouseIsOverRef.current = false;

    timeoutRef.current = setTimeout(() => {
      if (!mouseIsOverRef.current) {
        setIsOpen(false);
      }
    }, closeDelay);
  }, [closeDelay]);

  const handleClose = useCallback(() => {
    clearTimeouts();
    mouseIsOverRef.current = false;
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClose: handleClose,
  };
};

export type UseNavigationDropdownReturn = ReturnType<typeof useNavigationDropdown>; 